import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSingleStaticPage from '../useSingleStaticPage';
import { getStaticPageViewSections } from '../staticPageViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleStaticPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { singleItem, loading } = useSingleStaticPage();

  const sections = useMemo(
    () => getStaticPageViewSections(t, singleItem),
    [t, singleItem],
  );

  const pageTitle = singleItem?.title || t('Pagine Statiche');

  const listUrl = location.search
    ? `/website/static_pages${location.search}`
    : '/website/static_pages';

  const editUrl = location.search
    ? `/website/static_pages/edit/${singleItem?.id}${location.search}`
    : `/website/static_pages/edit/${singleItem?.id}`;

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleItem?.can_update !== false && (
            <Col>
              <Button>
                <Link to={editUrl}>{t('MODIFICA')}</Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={listUrl}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleStaticPage;
